import { YStack } from "tamagui";
import { H4 } from "tamagui";

export function CameraPopup() {
  return (
    <YStack ai="center" jc="center" flex={1}>
      <H4>Camera is not currently available on Web</H4>
    </YStack>
  );
}
